function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M80.8066 99.2595L99.5033 99.7025L101.819 107.88C102.593 110.611 100.541 113.324 97.7032 113.324H85.0847C82.722 113.324 80.8066 111.409 80.8066 109.046V99.2595Z",
  fill: "#666666"
}), /*#__PURE__*/React.createElement("mask", {
  id: "path-3-inside-1",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M90.4608 50.5121C90.6512 50.0041 90.8146 49.48 90.9491 48.9411C92.8614 41.2753 88.1754 33.5161 80.4827 31.6105C76.5908 30.6464 72.6749 31.3652 69.5078 33.3035C67.8394 29.2117 64.2983 25.9437 59.6677 24.7966C51.9749 22.891 44.1884 27.5605 42.2761 35.2263C41.2216 39.4533 42.1733 43.7086 44.5291 46.9954C40.1543 48.5517 36.6187 52.1917 35.414 57.0207C33.5586 64.4583 37.9145 71.9837 45.2014 74.1657C44.2618 81.2824 48.8162 88.1212 55.9727 89.894C60.2927 90.9641 64.6421 89.9608 67.9643 87.5178C68.8745 87.9658 69.8466 88.3239 70.8722 88.5779C78.5649 90.4836 86.3514 85.814 88.2638 78.1482C88.4411 77.4373 88.5617 76.7257 88.6284 76.0179C92.6815 74.3366 95.9112 70.8306 97.0516 66.259C98.6163 59.9866 95.7636 53.6518 90.4608 50.5121Z"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M90.4608 50.5121C90.6512 50.0041 90.8146 49.48 90.9491 48.9411C92.8614 41.2753 88.1754 33.5161 80.4827 31.6105C76.5908 30.6464 72.6749 31.3652 69.5078 33.3035C67.8394 29.2117 64.2983 25.9437 59.6677 24.7966C51.9749 22.891 44.1884 27.5605 42.2761 35.2263C41.2216 39.4533 42.1733 43.7086 44.5291 46.9954C40.1543 48.5517 36.6187 52.1917 35.414 57.0207C33.5586 64.4583 37.9145 71.9837 45.2014 74.1657C44.2618 81.2824 48.8162 88.1212 55.9727 89.894C60.2927 90.9641 64.6421 89.9608 67.9643 87.5178C68.8745 87.9658 69.8466 88.3239 70.8722 88.5779C78.5649 90.4836 86.3514 85.814 88.2638 78.1482C88.4411 77.4373 88.5617 76.7257 88.6284 76.0179C92.6815 74.3366 95.9112 70.8306 97.0516 66.259C98.6163 59.9866 95.7636 53.6518 90.4608 50.5121Z",
  fill: "#00B074"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.4608 50.5121L89.5224 50.1628L89.2295 50.9443L89.9491 51.3704L90.4608 50.5121ZM80.4827 31.6105L80.7243 30.6416L80.4827 31.6105ZM69.5078 33.3035L68.5798 33.6794L69.0247 34.7706L70.0319 34.1542L69.5078 33.3035ZM59.6677 24.7966L59.9094 23.8278L59.6677 24.7966ZM42.2761 35.2263L43.2482 35.4671L42.2761 35.2263ZM44.5291 46.9954L44.8659 47.9355L46.1154 47.491L45.3442 46.4151L44.5291 46.9954ZM35.414 57.0207L34.4419 56.7799L35.414 57.0207ZM45.2014 74.1657L46.1945 74.2959L46.3057 73.454L45.4897 73.2096L45.2014 74.1657ZM67.9643 87.5178L68.408 86.6227L67.8608 86.3534L67.3696 86.7145L67.9643 87.5178ZM88.6284 76.0179L88.2435 75.0963L87.6875 75.3269L87.6311 75.9246L88.6284 76.0179ZM91.3991 50.8614C91.6028 50.3179 91.7776 49.7576 91.9212 49.1819L89.977 48.7003C89.8517 49.2023 89.6995 49.6902 89.5224 50.1628L91.3991 50.8614ZM91.9212 49.1819C93.967 40.9809 88.9539 32.6802 80.7243 30.6416L80.241 32.5793C87.397 34.3519 91.7558 41.5696 89.977 48.7003L91.9212 49.1819ZM80.7243 30.6416C76.5611 29.6103 72.3703 30.3801 68.9836 32.4528L70.0319 34.1542C72.9794 32.3503 76.6204 31.6824 80.241 32.5793L80.7243 30.6416ZM70.4358 32.9277C68.6521 28.5529 64.8638 25.0551 59.9094 23.8278L59.426 25.7654C63.7328 26.8323 67.0267 29.8704 68.5798 33.6794L70.4358 32.9277ZM59.9094 23.8278C51.6798 21.7892 43.3498 26.7845 41.304 34.9855L43.2482 35.4671C45.027 28.3365 52.27 23.9928 59.426 25.7654L59.9094 23.8278ZM41.304 34.9855C40.1758 39.5078 41.1952 44.0615 43.714 47.5756L45.3442 46.4151C43.1515 43.3558 42.2674 39.3988 43.2482 35.4671L41.304 34.9855ZM44.1924 46.0552C39.5151 47.7192 35.7309 51.6129 34.4419 56.7799L36.3861 57.2615C37.5065 52.7706 40.7935 49.3843 44.8659 47.9355L44.1924 46.0552ZM34.4419 56.7799C32.4569 64.737 37.1169 72.7873 44.9131 75.1218L45.4897 73.2096C38.712 71.1801 34.6603 64.1796 36.3861 57.2615L34.4419 56.7799ZM44.2082 74.0355C43.203 81.6501 48.0744 88.9661 55.7311 90.8628L56.2144 88.9252C49.5579 87.2762 45.3207 80.9147 46.1945 74.2959L44.2082 74.0355ZM55.7311 90.8628C60.3528 92.0077 65.007 90.9331 68.5591 88.3211L67.3696 86.7145C64.2773 88.9885 60.2326 89.9206 56.2144 88.9252L55.7311 90.8628ZM67.5207 88.4129C68.4949 88.8924 69.5347 89.2753 70.6305 89.5467L71.1138 87.6091C70.1585 87.3725 69.2541 87.0392 68.408 86.6227L67.5207 88.4129ZM70.6305 89.5467C78.86 91.5854 87.19 86.59 89.2359 78.389L87.2917 77.9074C85.5128 85.0381 78.2698 89.3818 71.1138 87.6091L70.6305 89.5467ZM89.2359 78.389C89.4254 77.6295 89.5544 76.8685 89.6257 76.1112L87.6311 75.9246C87.5691 76.5828 87.4569 77.2452 87.2917 77.9074L89.2359 78.389ZM96.0795 66.0181C95.0188 70.27 92.0164 73.5312 88.2435 75.0963L89.0133 76.9396C93.3466 75.142 96.8035 71.3912 98.0237 66.4998L96.0795 66.0181ZM89.9491 51.3704C94.8826 54.2914 97.5346 60.1852 96.0795 66.0181L98.0237 66.4998C99.698 59.7881 96.6446 53.0123 90.9724 49.6538L89.9491 51.3704Z",
  fill: "#00453B",
  mask: "url(#path-3-inside-1)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M60.9255 71.0127C59.7713 69.7147 59.9464 67.6903 61.3067 66.6056C62.3764 65.7526 63.8755 65.7398 64.9519 66.5745L78.0735 76.7499L74.505 64.3598C74.1121 62.9954 74.9473 61.6312 76.3366 61.3682C77.4888 61.1502 78.671 61.7659 79.1665 62.8423L84.6568 74.7678L97.4489 93.6579L82.2588 102.689L73.3233 84.9547L60.9255 71.0127Z",
  fill: "#666666"
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 3.52549,
  ry: 3.51901,
  transform: "matrix(0.873437 -0.486937 0.48955 0.871975 45.4583 58.9133)",
  fill: "#00B074"
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 3.52549,
  ry: 3.51901,
  transform: "matrix(0.873437 -0.486937 0.48955 0.871975 59.4192 77.606)",
  fill: "#00B074"
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 3.52549,
  ry: 3.51901,
  transform: "matrix(0.873437 -0.486937 0.48955 0.871975 78.6087 43.886)",
  fill: "#00B074"
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 3.52549,
  ry: 3.51901,
  transform: "matrix(0.873437 -0.486937 0.48955 0.871975 64.7395 56.2212)",
  fill: "#00B074"
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 3.52549,
  ry: 3.51901,
  transform: "matrix(0.873437 -0.486937 0.48955 0.871975 88.9446 62.2969)",
  fill: "#00B074"
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 3.52549,
  ry: 3.51901,
  transform: "matrix(0.873437 -0.486937 0.48955 0.871975 55.2844 37.3201)",
  fill: "#00B074"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 24,
  y: 17,
  width: 89,
  height: 110,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 69,
  height: 90,
  fill: "white",
  transform: "translate(34 23)"
})));

var SvgTreeIcon = function SvgTreeIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTreeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tree-icon.21c81aaa.svg";
export { ForwardRef as ReactComponent };